import React, { useState, useEffect } from 'react'

import logo from './logo.svg'
import data from './data'
import Entry from './Entry'

const App = () => {
  const [mounted, setMounted] = useState(false)
  const [isCurtainClosed, setCurtainClosed] = useState(false)
  const [isArrowShowing, setArrowShowing] = useState(false)

  useEffect(() => {
    const body = document.getElementsByTagName('body')[0]
    body.style.overflow = isArrowShowing ? 'scroll' : 'hidden'
    const timer = setTimeout(() => setMounted(true), 150)
    return () => clearTimeout(timer)
  })

  return (
    <div>
      <header
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <img
          style={{
            zIndex: 10,
          }}
          src={logo}
          alt="logo"
        />
        <div style={{
          color: 'white',
          textAlign: 'center',
          fontSize: 'calc(1vw + 1vh + .5vmin)',
          lineHeight: 2,
          zIndex: 9,
          maxWidth: 700,
          padding: 24,
          fontWeight: 300,
          opacity: isCurtainClosed ? 1 : 0,
          transition: 'opacity 750ms ease-out'
        }}>
          Black Einstein Films is dedicated to creating artistic social commentary. It was founded by Taylor Black and Max Einstein in 2013.
        </div>

      </header>
      <a href={`#${data[0].slug}`}>
        <i
          className="fas fa-angle-down"
          onTransitionEnd={() => setArrowShowing(true)}
          style={{
            position: 'absolute',
            fontSize: 32,
            color: 'white',
            zIndex: 2,
            left: '50%',
            transform: 'translateX(-50%)',
            bottom: isCurtainClosed ? 50 : 0,
            opacity: isCurtainClosed ? 1 : 0,
            transition: 'all 500ms ease-out'
          }}
        />
      </a>
      <div
        onTransitionEnd={() => setCurtainClosed(true)}
        style={{
          zIndex: 1,
          background: 'black',
          position: 'absolute',
          height: '100vh',
          width: '100vw',
          bottom: mounted ? 0 : '100vh',
          transition: 'bottom 500ms ease-out'
        }}
      />
      {data.map((entry, idx) => (
        <Entry key={idx} {...entry} next={data[idx + 1]} />
      ))}
    </div>
  )
}

export default App
